/* eslint-disable @typescript-eslint/naming-convention -- x */
import axios from 'axios';

import { log } from './log';

interface SharedContent {
  message: string;
  url: string;
}

export const showSharePanel = async () => {
  const contentInfoUrl = '/system/ajax/CustomerOrderDetail/GetBasketLink';
  log('Opening sharing popup ...');
  const response = await axios.get<SharedContent>(`${window.location.origin}${contentInfoUrl}`, {
    headers: {
      'Cache-Control': 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'Service-Worker-Allowed': '/',
      Pragma: 'no-cache',
      Expires: '0',
    },
  });
  const { data } = response;

  const { message: originalMessage } = data;
  data.message = originalMessage.replace(/\n\n, /g, ', \n\n').replace(/\n{3}/g, '\n\n');

  return { data };
};
